import { Box, Tabs as MuiTabs } from '@mui/material'
import type React from 'react'

import type { Props as TabProps } from './MuiTabWrapper'
import MuiTabWrapper from './MuiTabWrapper'

type Props<T extends string> = {
  value: T
  onChange: (selected: T) => void
  config: TabProps<T>[]
}

const Tabs = <T extends string>({ value, onChange, config }: Props<T>) => {
  const handleChange = (_: React.SyntheticEvent, value: T | null) => {
    if (value !== null) {
      onChange(value)
    }
  }

  return (
    <Box borderBottom={1} borderColor="divider">
      <MuiTabs value={value} onChange={handleChange} aria-label="tabs">
        {config.map((conf, i) => (
          <MuiTabWrapper key={i} {...conf} />
        ))}
      </MuiTabs>
    </Box>
  )
}

export default Tabs
